import axios from "axios";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { UserRole } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/constants";
import { getAuthToken } from "utils/authUtils";

type PermissionsResponse = {
  crm: {
    eAudit: boolean;
    modifyProposal: boolean;
  };
};

const toolboxApiUrl =
  getEnvironment() === "production"
    ? "https://designtools.sunrun.com/api"
    : "https://devdesigntools.sunrun.com/api";

const getUserRole = async (inLightmile: boolean): Promise<UserRole> => {
  const token = await getAuthToken();
  const response = await axios.get<PermissionsResponse>(
    `${toolboxApiUrl}/v1/permissions`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    }
  );

  if (inLightmile) {
    return response.data?.crm?.eAudit || response.data?.crm?.modifyProposal
      ? "design"
      : "sales";
  }

  return response.data?.crm?.eAudit ? "design" : "sales";
};

export { getUserRole };
export type { PermissionsResponse };
